import { useEffect, useState } from "react";
import { AnimatePresence } from "framer-motion";

import { Banner,Button,Link} from "./CookieBanner.styled";
import Typography from "../Typography";

export default function CookieBanner() {
  const [visible, setVisible] = useState(false);

  const STORAGE_KEY = 'cookie_consent';
  const EXPIRATION_DAYS = 365;


  useEffect(() => {
    const stored = localStorage.getItem(STORAGE_KEY);

    if (stored) {
      try {
        const data = JSON.parse(stored);
        const now = Date.now();
        const expiresAt = data.expiresAt;

        if (now < expiresAt) return;
      } catch (e) {
        localStorage.removeItem(STORAGE_KEY);
      }
    }

    setVisible(true);
  }, []);

  const handleAccept = () => {
    const now = Date.now();
    const expiresAt = now + EXPIRATION_DAYS * 24 * 60 * 60 * 1000;

    const data = {
      accepted: true,
      expiresAt,
    };

    localStorage.setItem(STORAGE_KEY, JSON.stringify(data));

    setVisible(false);
  };

  return (
    <AnimatePresence>
      {visible && (
        <Banner
          initial={{ y: 100, opacity: 0 }}
          animate={{ y: 0, opacity: 1 }}
          exit={{ y: 100, opacity: 0 }}
          transition={{ duration: 0.4, ease: "easeOut" }}
        >
          <Typography variant="span" style={{fontSize: "14px"}}>
            Мы используем технические файлы cookie, необходимые для функционирования сайта. Подробнее можно ознакомиться{" "}
            <Link
              href="/doc/cookie-policy.pdf"
              target="_blank"
              rel="noopener noreferrer"
            >
              здесь
            </Link>
            .
          </Typography>
          <Button onClick={handleAccept}>Ознакомлен</Button>
        </Banner>
      )}
    </AnimatePresence>
  );
}